import { isDate } from 'moment/moment';

export const parseDateString = (value, originalValue) => {
    return (isDate(value) && originalValue?._isValid)
        ? value
        : null;
};